module.exports = __webpack_public_path__ + "static/img/frutuba-limao.6a9fce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/frutuba-limao.png
// module id = 9Mln
// module chunks = 0